
'use client';

import { useEffect } from 'react';
import { perf } from '@/lib/firebase';

export default function FirebasePerformance() {
  useEffect(() => {
    // This will initialize Firebase Performance on the client side.
    if (perf) {
      // The 'perf' object is already initialized in firebase.ts,
      // just importing it here and using it ensures the script is loaded and initialized.
    }
  }, []);

  return null;
}
